import { VIDEO_FILE, AUDIO_FILE } from '@shoflo/polymer/constants/SourceItems';
import setProgram from 'actions/Broadcast/setProgram';
import { setSceneLayout } from '@shoflo/studio-redux/actions';
import { SceneLayouts } from '@studio/constants/SceneLayouts';

const programChanged = (store, { program }) => {
  const { dispatch } = store;
  const { program: currentProgram } = store.getState();
  const layoutId = program?.layout || program?._id;
  const sceneLayout = SceneLayouts.find(({ id }) => id === layoutId);
  if (sceneLayout) {
    dispatch(setSceneLayout(sceneLayout));
  }
  if (document.visibilityState !== 'visible') {
    // Tab or window not in focus,
    // get the audio and video files currently playing and mute
    if (currentProgram) {
      const isAudioOrVideoPlaying = currentProgram.layers.filter(
        layer =>
          [VIDEO_FILE, AUDIO_FILE].includes(layer.source.type) &&
          layer.source.value.isPlaying &&
          !layer.source.value.muted
      ).length;

      if (isAudioOrVideoPlaying) {
        const muteMediaProgramLayers = currentProgram.layers.map(layer => {
          if (
            [VIDEO_FILE, AUDIO_FILE].includes(layer.source.type) &&
            layer.source.value.isPlaying &&
            !layer.source.value.muted
          ) {
            const mutedLayer = { ...layer };
            mutedLayer.source.value.muted = true;
            return mutedLayer;
          }
          return layer;
        });
        dispatch(
          setProgram(
            {
              ...program,
              layers: muteMediaProgramLayers
            },
            false,
            { emitSocket: false }
          )
        );
      }
    }
  }
  //It was observed that this has been empty on occasion, which is not valid
  if (!program) return;

  //TODO: why are we doing this? It should not necessary, a falsey programs or
  //      layers are not valid and should be addressed when building the scene/program
  const programLayer = program?.layers.filter(
    layer => layer !== null && layer !== undefined
  );
  dispatch(
    setProgram(
      {
        ...program,
        layers: programLayer
      },
      false,
      { emitSocket: false }
    )
  );
};

export default programChanged;
